var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifficult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.49 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.8,58.75H8.47v-18.12C3.73,36.43.75,30.38.75,23.66.75,11,11.27.75,24.24.75s23.47,10.25,23.47,22.91c0,.87-.05,1.74-.15,2.6-.05.43.03.86.24,1.23l4.71,8.26c.57.98,0,2.21-1.1,2.45l-4.84,1v7.84c0,1.35-1.1,2.45-2.47,2.45h-10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.52,45.09l1.68,1.67c1.74,1.74,4.11,2.72,6.58,2.72"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.8,
    y1: 49.48,
    x2: 35.8,
    y2: 58.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.62,10.97l-2.69,2.69c-1.08,1.08-2.84,1.08-3.92,0l-2.69-2.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.32,26.38l2.69-2.69c1.08-1.08,2.84-1.08,3.92,0l2.69,2.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.68,23.32l-2.69-2.69c-1.08-1.08-1.08-2.84,0-3.92l2.69-2.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.27,14.03l2.69,2.69c1.08,1.08,1.08,2.84,0,3.92l-2.69,2.69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifficult);
export default __webpack_public_path__ + "static/media/difficult.01ab7eda33a7b20742cdb929b102e217.svg";
export { ForwardRef as ReactComponent };